import List from './list/LabResearchReasonListInitialState'

const { Record } = require('immutable')

export default Record({
    list: List()
})